import {
    ADD_CONTACT,
    FETCH_PARTNER_REQUEST,
    PARTNER_ERROR,
    SAVE_CONTACT,
    GET_ALL_PARTNERS,
    GET_SELECTED_PARTNER,
    STORE_ADDED_CONTACT,
    GET_SOME_PARTNERS,
    GET_PARTNER_OFFERINGS,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getPartners = () => async () => {
        try {
            var response = await axiosCall.get('partners');
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getPartnersWithDomain = (accountId) => async () => {
        try {
            var response = await axiosCall.get('partners/withdomain?accountId=' + accountId);
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const addInitialContacts = (contact) => {
        return {
            type: ADD_CONTACT,
            payload: contact,
        };
    };

    const fetchPartnerRequest = () => {
        return {
            type: FETCH_PARTNER_REQUEST,
        };
    };

    const getPartner = (partnerId) => async () => {
        try {
            var response = await axiosCall.get('partners/' + partnerId);
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getAllPartners = (allPartners) => {
        return {
            type: GET_ALL_PARTNERS,
            payload: allPartners,
        };
    };

    const partnerError = (error) => {
        return {
            type: PARTNER_ERROR,
            payload: error,
        };
    };

    const saveContact = (newContactInfo) => {
        return {
            payload: newContactInfo,
            type: SAVE_CONTACT,
        };
    };

    const getSelectedPartner = (partnerData) => {
        return {
            type: GET_SELECTED_PARTNER,
            payload: partnerData,
        };
    };

    const storeAddedContact = (contact) => {
        return {
            type: STORE_ADDED_CONTACT,
            payload: contact,
        };
    };

    const getSomePartners = (partnerData) => {
        return {
            type: GET_SOME_PARTNERS,
            payload: partnerData,
        };
    };

    const getPartnerOfferings = (offerings) => {
        return {
            type: GET_PARTNER_OFFERINGS,
            payload: offerings,
        };
    };

    const fetchAllPartners = () => {
        return async (dispatch) => {
            try {
                dispatch(fetchPartnerRequest);
                var response = await axiosCall.get(`partners`);
                const allPartners = response.data.data.items;
                dispatch(getAllPartners(allPartners));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(partnerError(errorMsg));
            }
        };
    };

    const createNewPartner = (payload) => async() => axiosCall.post('partners', {...payload});

    return {
        addInitialContacts,
        createNewPartner,
        fetchAllPartners,
        fetchPartnerRequest,
        getAllPartners,
        getPartner,
        getPartnerOfferings,
        getPartners,
        getPartnersWithDomain,
        getSelectedPartner,
        getSomePartners,
        partnerError,
        saveContact,
        storeAddedContact,
    };
};

export default initActions;
